import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch, store } from "../../../../redux/store";
import { fetchBillingCodes } from "../actions";
import {
  addBillingCode,
  updateBillingCode,
  deleteBillingCode,
} from "../reducer";
import MainTable from "../../../../components/mainTable";
import { getBillingCodesTableColumns } from "../../../../shared/tableColumns/billingCodesColumns";
import {
  showModal,
  hideModal,
} from "../../../../connected-components/modal/reducer";
import { ModalType } from "../../../../shared/utils/enums";
import { BillingCode } from "../../../../interfaces/screens/billing";
import BillingCodeEditor from "../../../../components/BillingCodeEditor";

const BillingCodes = () => {
  const dispatch: AppDispatch = useDispatch();
  const {
    data: billingCodes,
    loading,
    error,
  } = useSelector((state: RootState) => state.billing.billingCodes);

  useEffect(() => {
    dispatch(fetchBillingCodes());
  }, [dispatch]);

  const handleNewCode = () => {
    dispatch(
      showModal({
        title: "Create New Billing Code",
        type: ModalType.COMPONENT,
        component: (
          <BillingCodeEditor
            key="new-billing-code"
            onClose={() => store.dispatch(hideModal())}
            onSave={(code: BillingCode) => {
              dispatch(addBillingCode({ ...code, id: `new_${Date.now()}` }));
            }}
          />
        ),
      })
    );
  };

  const handleEditCode = (code: BillingCode) => {
    dispatch(
      showModal({
        title: `Edit Billing Code: ${code.code}`,
        type: ModalType.COMPONENT,
        component: (
          <BillingCodeEditor
            key={code.id}
            code={code}
            onClose={() => store.dispatch(hideModal())}
            onSave={(updatedCode: BillingCode) => {
              dispatch(updateBillingCode(updatedCode));
            }}
          />
        ),
      })
    );
  };

  const handleDeleteCode = (code: BillingCode) => {
    dispatch(
      showModal({
        title: `Delete Billing Code: ${code.code}`,
        type: ModalType.QUESTION,
        onConfirm: () => {
          dispatch(deleteBillingCode(code.id));
          store.dispatch(hideModal());
        },
        message: `Are you sure you want to delete the billing code "${code.code} - ${code.description}"? This action cannot be undone.`,
      }),
    );
  };

  const columns = getBillingCodesTableColumns({
    onEdit: handleEditCode,
    onDelete: handleDeleteCode,
  });

  return (
    <div className="pt-4">
      <MainTable
        data={billingCodes}
        columns={columns}
        isLoading={loading}
        showAddButton={true}
        addButtonLabel="New Billing Code"
        onAddNewItemPress={handleNewCode}
      />
      {error && (
        <p className="text-red-500 mt-4">Error fetching billing codes: {error}</p>
      )}
    </div>
  );
};

export default BillingCodes; 